import React, { useEffect, useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { ThemeContext } from 'styled-components'

import { Grid, Box } from '@chatterbug/aaron'

import resizeMasonryItem from './calculateGridItemHeight'
const MasonryGrid = ({ items, renderGridContent }) => {
  const themeContext = useContext(ThemeContext)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const tabletSize = parseInt(themeContext.breakpoints.tablet, 10)
  useEffect(() => {
    // so it doesn't look weird when resizing
    function handleResize() {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    if (windowWidth >= tabletSize) {
      const allItems = document.getElementsByClassName('masonry-brick')
      // converting HTML collection to an array, for forEach to work
      Array.from(allItems).forEach((item) => resizeMasonryItem(item))
    }
    return () => window.removeEventListener('resize', handleResize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowWidth])

  return (
    <Grid
      className="masonry"
      columns={{ _: '1fr', tablet: 'repeat(3, 1fr)' }}
      gap="2x"
      gridAutoRows={{ _: 'auto', tablet: 0 }}
    >
      {items.map((item, index) => {
        return (
          <Box className="masonry-brick" key={`grid-item-${index}`}>
            <Box className="masonry-content">{renderGridContent(item)}</Box>
          </Box>
        )
      })}
    </Grid>
  )
}
MasonryGrid.propTypes = {
  renderGridContent: PropTypes.func.isRequired,
  items: PropTypes.array,
}
export default MasonryGrid
